import { styled } from '@precis-digital/kurama/utils'
import Typography from '@precis-digital/kurama/Typography'

export const StyledTypography1LineClamp = styled(Typography)(() => ({
  display: '-webkit-box',
  WebkitLineClamp: '1',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}))
